import {
  useEffect,
  useState
} from 'react';

import {
  AdvanceProvider
} from 'journeys';

import {
  CatalogueProvider
} from '../providers';

import {
  CacheKeys
} from '../../../../constants';

export const useCatalogue = (
  vendorId,
  fetchAllProducts = false,
  voucherId
  ) => {

  const [ catalogue, setCatalogue ] = useState({
    isLoading: true,
    isError: false,
    content: null
  });

  const findVendor = (
    categoryList,
    id
    ) => {

    if (!categoryList) {

      return;
    }

    for (const category of categoryList) {

      if (!Array.isArray(category?.vendors) || !category?.vendors?.length) {
        continue;
      }

      for (const vendor of category.vendors) {

        if (!vendor) {
          continue;
        }

        if (vendor.id?.toString() === id?.toString()) {
          return [ category.name, vendor ];
        }
      }
    }
  };

  const getProductList = async (products) => {

    if (!fetchAllProducts) {
      return products;
    }

    let productList = [];

    for (const product of products) {

      if (!product) {
        continue;
      }

      const productResponse = await CatalogueProvider.getCachedItem(
        `${CacheKeys.VoucherAdvanceProductInfo}-${product.id}`,
        null,
        () => CatalogueProvider.productOffering(product.id)
      );

      if (!productResponse?.ok || !productResponse?.result || !productResponse?.result?.name) {
        continue;
      }

      productList.push(productResponse?.result);
    }

    return productList;
  };

  const findProduct = (products, id) => {

    for (let i = 0; i < products.length; i ++) {

      if (products[i].id === id) {

        return products[i];
      }
    }

    return;
  };

  const getContent = async () => {

    const eligibilityResponse = await AdvanceProvider.getCachedItem(CacheKeys.VoucherAdvanceEligibility);

    let eligibility = eligibilityResponse?.ok && eligibilityResponse?.result
      ? eligibilityResponse.result
      : false;

    const categoryResponse = await CatalogueProvider.getCachedItem(
      CacheKeys.VoucherAdvanceCategories,
      null,
      CatalogueProvider.listCategory
    );

    const [ category, vendorDetails ] = findVendor(categoryResponse?.result, vendorId) || [ null, null ];

    const productListResponse = await CatalogueProvider.getCachedItem(
      `${CacheKeys.VoucherAdvanceProductList}-${vendorId}`,
      null,
      () => CatalogueProvider.listProductOffering(vendorId)
    );

    if (!productListResponse?.result) {

      setCatalogue(prevState => ({
        ...prevState,
        isLoading: false,
        isError: true
      }));

      return;
    }

    const products = productListResponse.result;
    products?.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

    const productList = await getProductList(products);

    const lowestPrice = products?.[0]?.price;
    const vendorImage = products?.find(product => !!product?.url)?.url;

    if (!productList?.length || !vendorDetails) {

      setCatalogue(prevState => ({
        ...prevState,
        isLoading: false,
        isError: true,
        content: null
      }));

      return;
    }

    if (!!voucherId) {

      const product = findProduct(productList, voucherId);

      if (!product) {

        setCatalogue(prevState => ({
          ...prevState,
          isLoading: false,
          isError: true
        }));

        return;
      }

      setCatalogue(prevState => ({
        ...prevState,
        isLoading: false,
        isError: false,
        category: category,
        product: product,
        vendor: vendorDetails,
        eligibility: eligibility
      }));

      return;
    }

    setCatalogue(prevState => ({
      ...prevState,
      isLoading: false,
      isError: false,
      content: {
        ...vendorDetails,
        category: category,
        lowestPrice: lowestPrice,
        vendorImage: vendorImage,
        products: productList,
        eligibility: eligibility
      }
    }));

    return;
  };

  useEffect(() => {

    getContent();
  }, []);

  return catalogue;
};